import defaultUrl from './api.js';
const urls = {
    // 首页孵化基地园区推荐
    homeGardenRecommend: '/api/Garden/headrecommend',
    // 挂牌企业列表数据
    companyList: '/api/Company/list',
    // 首页产业研究列表数据
    homeResearchList: '/api/Research/list/',
    // 挂牌企业行业分类数据
    listedIndustryClassify: '/internal/industry_Category_Controller/classify',
    // 企业基本信息
    companyInfo: '/api/company/index/',
    // 公司股东列表
    companyShareholder: '/api/company/guDong/',
    // 公司高管列表
    companyManage: '/api/company/manage/',
    // 企业相关公告列表
    companyAnnouncement: '/api/company/gongGao/',
    // 企业财务指标
    companyFinancialIndex: '/api/Company/caiWuZhiBiao/',
    // 孵化基地区域数据
    areaList: '/internal/Street_Category_Controller/classify',
    // 孵化基地产业定制
    gardenCustomization: '/api/Garden/customization',
    // 孵化基地国际化园区
    gardenInternationalization: '/api/Garden/internationalization',
    // 孵化基地火热招商
    gardenHot: '/api/Garden/hot',
    // 孵化基地明星园区
    gardenStar: '/api/Garden/star',
    // 孵化基地示范园区
    gardenDemonstration: '/api/Garden/demonstration',
    // 孵化基地园区列表
    gardenList: '/api/Garden/list/',
    // 孵化基地园区详情
    gardenDetail: '/api/Garden/listDetail/',
    // 孵化基地园区招商政策
    gardenInvestmentPolicy: '/api/Garden/zhengCe/',
    // 孵化基地园区挂牌企业
    gardenCompanys: '/api/Company/companys',
    // 孵化基地园区动态列表
    gardenNews: '/api/Garden/news/',
    // 百校千人计划
    formSchools: '/api/form/schools',
    // 专利加速器
    formPatent: '/api/form/patent',
    // 丝路商考计划
    formRoad: '/api/form/road',
    // 产业集群分类列表
    baseTypeList: '/internal/Collective_Category_Controller/collectivetype',
    // 产业集群院校专家列表
    baseStudyExpert: '/api/Study/expert/',
    // 产业集群专家委员会列表
    baseCommitteeList: '/api/Committee/list/',
    // 产业集群示范街道
    baseStreetDemonstration: '/api/Street/demonstration',
    // 产业集群相关街道
    baseStreetRelated: '/api/Street/related',
    // 产业集群示范园区
    baseGardenDemonstration: '/api/Garden/demonstration_garden/',
    // 产业集群相关园区
    baseGardenRelated: '/api/Garden/related/',
    // 产业集群学术平台列表
    baseStudyList: '/api/Study/list/',
    // 产业集群学术平台详情
    baseStudyListDetail: '/api/Study/listDetail',
    // 学术平台成果展示
    studyAchievements: '/api/study/GetStudyAchievements',
    // 院校实验室列表
    baseStudyLaboratory: '/api/Study/laboratory/',
    // 院校出版物列表
    baseStudyPublication: '/api/Study/Publication/',
    // 院校活动列表
    baseStudyActivity: '/api/Study/Meeting/',
    // 产业集群产业研究列表
    baseResearchList: '/api/Research/list/',
    // 产业集群活动列表
    baseMeetingList: '/api/Meeting/industrial_list',
    // 产业集群协会列表
    baseSocietyList: '/api/Society/list',
    // 产业集群协会详情
    baseSocietyListDetail: '/api/Society/listDetail',
    // 产业集群产业链列表
    baseChainList: '/api/chain/list',
    // 产业集群产业链详情
    baseChainListDetail: '/api/chain/listDetail',
    // 产业集群街道详情
    baseStreetDetail: '/api/Street/listDetail/',
    // 产业政策
    industrialPolicy: '/api/Street/index/',
    // 融媒体
    fusionMedia: '/api/Street/media/',
    // 社区数据
    streetCommunity: '/api/Street/sheQu/',
    // 街道>>园区列表
    streetGardenList: '/api/Garden/list/',
    // 与投资者关系7个汇总数据
    companyRecord: '/api/company/record',
    // 与投资者关系公告列表
    afficheList: '/api/Affiche/list',
    // 与投资者关系通知文章
    informationList: '/api/Information/list',
    // 与投资者关系挂牌融资
    financeInformationList: '/api/Finance_Information/list',
    // 与投资者关系孵化成果列表
    hatchingList: '/api/Hatching/list',
    // 投资者数据库
    investorDataBase: '/internal/Investor_Controller/list',
    // 提交计划书
    stockAdd: '/api/stock/add',
    // 系统规则>法律法规
    lawsList: '/api/Laws/list',
    // 系统规则>红筹规则
    ruleList: '/api/Rule/list',
    // 街道导航
    streetNavData: '/api/Street/list',
    // 协会列表总数据
    associationTotalList: '/api/association/list',
    // 协会列表
    associationList: '/api/association/collective_list',
    // 协会详情
    associationDetail: '/api/association/detail',
    // 协会领导
    associationLeaders: '/api/association/leaders',
    // 协会动态
    associationDynamic: '/api/association/dynamic',
    // 协会产业动态
    associationIndustry: '/api/association/industry',
    // 协会会员
    associationPublication: '/api/association/publication',
    // 文章详情
    articlesDetail: '/api/articles/detail', 
    // 文章详情页点赞
    praise: '/api/articles/zan',
    // 文章详情页上下篇
    prevNextArticle: '/api/articles/near',
};
// 接口拼接
var baseUrl = defaultUrl;
Object.keys(urls).forEach(el => {
    urls[el] = baseUrl + urls[el];
});
export default urls;


// WEBPACK FOOTER //
// ./src/api/apiUrl.js